module.exports = __webpack_public_path__ + "static/media/sample.500a0a51.md";